<app-page-heading [key]="'user-dashboard.users.plant-managers.list.page-title'"></app-page-heading>

<section class="container summary-panel">
    <div class="row">


        <div class="col-md-12">
            <app-data-filters #dataFilters class="pull-left" [disableSearch]="emailFilter.minLengthInvalid">
                <app-data-filter-group>
                    <app-data-filter-input
                        #emailFilter
                        [labelKey]="'user-dashboard.users.list.filters.email.label'"
                        [(model)]="filters.email"
                        [minLength]="3"
                        [helperKey]="'user-dashboard.users.list.filters.email.helper'"
                        [placeholderKey]="'user-dashboard.users.list.filters.email.placeholder'"></app-data-filter-input>
                </app-data-filter-group>
            </app-data-filters>
            <button class="btn btn-primary btn-lg pull-right" (click)="goToCreatePlantManager()">
                <span class="fa fa-plus"></span>
                <span [i18n]="[{target: 'innerHTML', key: 'user-dashboard.users.plant-managers.list.buttons.create-plant-manager'}]"></span>
            </button>
            <br>
        </div>
    </div>

    <br>

    <div class="row">
        <div class="col-md-12">
            <div class="ibox float-e-margins">
                <div class="ibox-content no-padding">
                    <app-user-table (edit)="goToEditPlantManager($event)"
                                    *ngIf="plants.length !== 0"
                                    [loadPage]="loadPage"
                                    [(filters)]="filters"
                                    (filtersReset)="filters.reset()"
                                    [filtersComponent]="dataFilters"
                                    [showPlants]="true"></app-user-table>
                </div>
            </div>
        </div>
    </div>
</section>
